import React, { Component } from 'react';
import { Routes } from "./Routes/Routes";
import { getBrowser , isMobile} from './Utility/Utility'
import './App.css';
import Loader  from './Components/Loader/Loader';
class App extends Component {

 constructor (){
 	super();

  this.state = { 
    isLoading : true,
    currentBrowser : getBrowser()
  }

  


 	// https://tc39.github.io/ecma262/#sec-array.prototype.find
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function(predicate) {
       // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      }
    });
  }

 }

  handleLoader = () => {
    this.setState({
      isLoading:false
    })
  }
  render() {

    let cssClass = 'desktopVersion ';

    if ( isMobile() ) {
        cssClass = ' MobileVersion ';
    }
    var version =  this.state.currentBrowser.version;
    version  = parseInt(version);
  
    // alert(this.state.currentBrowser)
    let html = <div className={'App ' + this.state.currentBrowser.name + '  ' +  this.state.currentBrowser.name +'-' +  version + ' ' + cssClass}>
                  { void window.scrollTo(0, 0) }
                  <Routes />
              </div>

    if (this.state.isLoading === true){
       html = <div  className={'App ' + this.state.currentBrowser }>
               <Loader />
              </div>
      window.setTimeout( ()=>{
        this.handleLoader()
      },500)
    }
    return (html);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js